export const starterItems = [
  3599,
  1083,
  1082,
  1055,
  1056,
  1054,
  3177,
  3184,
  2051,
  3112,
  1102, // Gustwalker Hatchling
  1103, // Mosstomper Seedling
  3858,
  1101, // Scorchclaw Pup
  3862,
  3850,
  3854,
  3070,
];

export const consumableItems = [2055, 2033, 2138, 2139, 2140, 2003, 2031];

export const trinketItems = [3363, 3364, 3340];

export const distributedItems = [3400, 2419, 3513, 2403, 2423, 2052, 2422, 2010];

export const bootsItems = [3006, 1001, 3009, 3158, 3111, 3117, 3047, 3020];

export const basicItems = [1052, 1038, 1026, 1018, 1029, 1042, 1004, 1036, 1058, 1033, 1037, 1006, 1028, 1027, 3057, 2420];

export const epicItems = [
  3105, 3113, 6660, 4642, 4630, 3076, 3803, 3133, 1031, 3801, 3123, 3108, 3114, 3851, 1011, 3024, 3863, 3051, 3155, 3145, 6029,
  3067, 2015, 3035, 4635, 3802, 1057, 6670, 3916, 3044, 3140, 6677, 1043, 3855, 3191, 3134, 3211, 3859, 3077, 1053, 4632, 3082,
  4638, 3066, 3086,
];

export const legendaryItems = [
  8020,
  8001,
  3003,
  3504,
  6696,
  3102,
  3071, // Black Cleaver
  3864, // Black Mist Scythe
  3153,
  3072, // Bloodthirster
  3860, // Bulwark of the Mountain
  6609,
  3011,
  4629,
  3742,
  6333,
  4637,
  3814,
  3508,
  3121,
  4401,
  3110,
  3193,
  3026,
  3124,
  4628,
  3181,
  3031,
  3109,
  3100,
  3036,
  3004,
  3156,
  3041,
  3139,
  3222,
  3165,
  3033,
  3042,
  3115,
  6675,
  3857, // Pauldrons of Whiterock
  3046,
  3089,
  3143,
  3094,
  3074,
  3107,
  3085,
  3116,
  3040,
  6695,
  6694,
  4645,
  3853, // Shard of True Ice
  6035,
  3161,
  3065,
  6616,
  3053,
  3095,
  3068,
  6676,
  3075,
  3748,
  6664,
  3179,
  3135,
  3083,
  4638,
  3119,
  3091,
  3142,
  3050,
  3157,
];

export const mythicItems = [
  4644, 6632, 6691, 6692, 3001, 6656, 6671, 6630, 3084, 3152, 6662, 6673, 4005, 6665, 6672, 6653, 3190, 6655, 6617, 4636, 6693,
  6667, 4633, 6657, 2065, 6631, 3078,
];

export const ornnItems = [
  7008, // Bloodward
  7024, // Caesura
  7015, // Ceaseless Hunger
  7017, // Decide
  7002, // Draktharr's Shadowcarver
  7016, // Dreamshatter
  7023, // Equinox
  7014, // Eternal Winter
  7013, // Eye of Luden
  7005, // Frozen Fist
  7009, // Icathia's Curse
  7028, // Infinite Convergence
  7018, // Infinity Force
  7025, // Leviathan
  7012, // Liandry's Lament
  7027, // Primordial Dawn
  7019, // Reliquary of the Golden Dawn
  7000, // Sandshrike's Claw
  7022, // Seat of Command
  7020, // Shurelya's Requiem
  7021, // Starcaster
  7001, // Syzygy
  7026, // The Unspoken Parasite
  7006, // Typhoon
  7011, // Upgraded Aeropack
  7010, // Vespertide
  7007, // Wyrmfallen Sacrifice
];

export const availableItems = [
  ...starterItems,
  ...consumableItems,
  ...trinketItems,
  ...distributedItems,
  ...bootsItems,
  ...basicItems,
  ...epicItems,
  ...legendaryItems,
  ...mythicItems,
  ...ornnItems,
];

export const itemNormalizedNames = {
  1001: { originalName: "Boots", normalizedName: "boots" },
  1004: { originalName: "Faerie Charm", normalizedName: "faerie-charm" },
  1006: {
    originalName: "Rejuvenation Bead",
    normalizedName: "rejuvenation-bead",
  },
  1011: { originalName: "Giant's Belt", normalizedName: "giants-belt" },
  1018: {
    originalName: "Cloak of Agility",
    normalizedName: "cloak-of-agility",
  },
  1026: { originalName: "Blasting Wand", normalizedName: "blasting-wand" },
  1027: {
    originalName: "Sapphire Crystal",
    normalizedName: "sapphire-crystal",
  },
  1028: { originalName: "Ruby Crystal", normalizedName: "ruby-crystal" },
  1029: { originalName: "Cloth Armor", normalizedName: "cloth-armor" },
  1031: { originalName: "Chain Vest", normalizedName: "chain-vest" },
  1033: {
    originalName: "Null-Magic Mantle",
    normalizedName: "null-magic-mantle",
  },
  1035: { originalName: "Emberknife", normalizedName: "emberknife" },
  1036: { originalName: "Long Sword", normalizedName: "long-sword" },
  1037: { originalName: "Pickaxe", normalizedName: "pickaxe" },
  1038: { originalName: "B. F. Sword", normalizedName: "b-f-sword" },
  1039: { originalName: "Hailblade", normalizedName: "hailblade" },
  1040: { originalName: "Obsidian Edge", normalizedName: "obsidian-edge" },
  1042: { originalName: "Dagger", normalizedName: "dagger" },
  1043: { originalName: "Recurve Bow", normalizedName: "recurve-bow" },
  1052: { originalName: "Amplifying Tome", normalizedName: "amplifying-tome" },
  1053: {
    originalName: "Vampiric Scepter",
    normalizedName: "vampiric-scepter",
  },
  1054: { originalName: "Doran's Shield", normalizedName: "dorans-shield" },
  1055: { originalName: "Doran's Blade", normalizedName: "dorans-blade" },
  1056: { originalName: "Doran's Ring", normalizedName: "dorans-ring" },
  1057: { originalName: "Negatron Cloak", normalizedName: "negatron-cloak" },
  1058: {
    originalName: "Needlessly Large Rod",
    normalizedName: "needlessly-large-rod",
  },
  1082: { originalName: "Dark Seal", normalizedName: "dark-seal" },
  1083: { originalName: "Cull", normalizedName: "cull" },
  1101: { originalName: "Scorchclaw Pup", normalizedName: "scorchclaw-pup" },
  1102: { originalName: "Gustwalker Hatchling", normalizedName: "gustwalker-hatchling" },
  1103: { originalName: "Mosstomper Seedling", normalizedName: "mosstomper-seedling" },
  1500: {
    originalName: "Penetrating Bullets",
    normalizedName: "penetrating-bullets",
  },
  1501: { originalName: "Fortification", normalizedName: "fortification" },
  1502: {
    originalName: "Reinforced Armor",
    normalizedName: "reinforced-armor",
  },
  1503: { originalName: "Warden's Eye", normalizedName: "wardens-eye" },
  1504: { originalName: "Vanguard", normalizedName: "vanguard" },
  1505: { originalName: "Lightning Rod", normalizedName: "lightning-rod" },
  1506: {
    originalName: "Reinforced Armor",
    normalizedName: "reinforced-armor",
  },
  1507: { originalName: "Overcharged", normalizedName: "overcharged" },
  1508: {
    originalName: "Anti-tower Socks",
    normalizedName: "anti-tower-socks",
  },
  1509: { originalName: "Gusto", normalizedName: "gusto" },
  1510: { originalName: "Phreakish Gusto", normalizedName: "phreakish-gusto" },
  1511: {
    originalName: "Super Mech Armor",
    normalizedName: "super-mech-armor",
  },
  1512: {
    originalName: "Super Mech Power Field",
    normalizedName: "super-mech-power-field",
  },
  1515: { originalName: "Turret Plating", normalizedName: "turret-plating" },
  1516: {
    originalName: "Structure Bounty",
    normalizedName: "structure-bounty",
  },
  1517: {
    originalName: "Structure Bounty",
    normalizedName: "structure-bounty",
  },
  1518: {
    originalName: "Structure Bounty",
    normalizedName: "structure-bounty",
  },
  1519: {
    originalName: "Structure Bounty",
    normalizedName: "structure-bounty",
  },
  2003: { originalName: "Health Potion", normalizedName: "health-potion" },
  2010: {
    originalName: "Total Biscuit of Everlasting Will",
    normalizedName: "total-biscuit-of-everlasting-will",
  },
  2015: { originalName: "Kircheis Shard", normalizedName: "kircheis-shard" },
  2031: {
    originalName: "Refillable Potion",
    normalizedName: "refillable-potion",
  },
  2033: {
    originalName: "Corrupting Potion",
    normalizedName: "corrupting-potion",
  },
  2051: { originalName: "Guardian's Horn", normalizedName: "guardians-horn" },
  2052: { originalName: "Poro-Snax", normalizedName: "poro-snax" },
  2055: { originalName: "Control Ward", normalizedName: "control-ward" },
  2065: {
    originalName: "Shurelya's Battlesong",
    normalizedName: "shurelyas-battlesong",
  },
  2138: { originalName: "Elixir of Iron", normalizedName: "elixir-of-iron" },
  2139: {
    originalName: "Elixir of Sorcery",
    normalizedName: "elixir-of-sorcery",
  },
  2140: { originalName: "Elixir of Wrath", normalizedName: "elixir-of-wrath" },
  2403: {
    originalName: "Minion Dematerializer",
    normalizedName: "minion-dematerializer",
  },
  2419: {
    originalName: "Commencing Stopwatch",
    normalizedName: "commencing-stopwatch",
  },
  2420: { originalName: "Stopwatch", normalizedName: "stopwatch" },
  2421: {
    originalName: "Broken Stopwatch",
    normalizedName: "broken-stopwatch",
  },
  2422: {
    originalName: "Slightly Magical Footwear",
    normalizedName: "slightly-magical-footwear",
  },
  2423: {
    originalName: "Perfectly Timed Stopwatch",
    normalizedName: "perfectly-timed-stopwatch",
  },
  2424: {
    originalName: "Broken Stopwatch",
    normalizedName: "broken-stopwatch",
  },
  3001: { originalName: "Evenshroud", normalizedName: "evenshroud" },
  3003: {
    originalName: "Archangel's Staff",
    normalizedName: "archangels-staff",
  },
  3004: { originalName: "Manamune", normalizedName: "manamune" },
  3006: {
    originalName: "Berserker's Greaves",
    normalizedName: "berserkers-greaves",
  },
  3009: {
    originalName: "Boots of Swiftness",
    normalizedName: "boots-of-swiftness",
  },
  3011: {
    originalName: "Chemtech Putrifier",
    normalizedName: "chemtech-putrifier",
  },
  3020: { originalName: "Sorcerer's Shoes", normalizedName: "sorcerers-shoes" },
  3024: { originalName: "Glacial Buckler", normalizedName: "glacial-buckler" },
  3026: { originalName: "Guardian Angel", normalizedName: "guardian-angel" },
  3031: { originalName: "Infinity Edge", normalizedName: "infinity-edge" },
  3033: { originalName: "Mortal Reminder", normalizedName: "mortal-reminder" },
  3035: { originalName: "Last Whisper", normalizedName: "last-whisper" },
  3036: {
    originalName: "Lord Dominik's Regards",
    normalizedName: "lord-dominiks-regards",
  },
  3040: { originalName: "Seraph's Embrace", normalizedName: "seraphs-embrace" },
  3041: {
    originalName: "Mejai's Soulstealer",
    normalizedName: "mejais-soulstealer",
  },
  3042: { originalName: "Muramana", normalizedName: "muramana" },
  3044: { originalName: "Phage", normalizedName: "phage" },
  3046: { originalName: "Phantom Dancer", normalizedName: "phantom-dancer" },
  3047: {
    originalName: "Plated Steelcaps",
    normalizedName: "plated-steelcaps",
  },
  3050: {
    originalName: "Zeke's Convergence",
    normalizedName: "zekes-convergence",
  },
  3051: { originalName: "Hearthbound Axe", normalizedName: "hearthbound-axe" },
  3053: { originalName: "Sterak's Gage", normalizedName: "steraks-gage" },
  3057: { originalName: "Sheen", normalizedName: "sheen" },
  3065: { originalName: "Spirit Visage", normalizedName: "spirit-visage" },
  3066: {
    originalName: "Winged Moonplate",
    normalizedName: "winged-moonplate",
  },
  3067: { originalName: "Kindlegem", normalizedName: "kindlegem" },
  3068: { originalName: "Sunfire Aegis", normalizedName: "sunfire-aegis" },
  3070: {
    originalName: "Tear of the Goddess",
    normalizedName: "tear-of-the-goddess",
  },
  3071: { originalName: "Black Cleaver", normalizedName: "black-cleaver" },
  3072: { originalName: "Bloodthirster", normalizedName: "bloodthirster" },
  3074: { originalName: "Ravenous Hydra", normalizedName: "ravenous-hydra" },
  3075: { originalName: "Thornmail", normalizedName: "thornmail" },
  3076: { originalName: "Bramble Vest", normalizedName: "bramble-vest" },
  3077: { originalName: "Tiamat", normalizedName: "tiamat" },
  3078: { originalName: "Trinity Force", normalizedName: "trinity-force" },
  3082: { originalName: "Warden's Mail", normalizedName: "wardens-mail" },
  3083: { originalName: "Warmog's Armor", normalizedName: "warmogs-armor" },
  3084: { originalName: "Heartsteel", normalizedName: "heartsteel" },
  3085: {
    originalName: "Runaan's Hurricane",
    normalizedName: "runaans-hurricane",
  },
  3086: { originalName: "Zeal", normalizedName: "zeal" },
  3089: {
    originalName: "Rabadon's Deathcap",
    normalizedName: "rabadons-deathcap",
  },
  3091: { originalName: "Wit's End", normalizedName: "wits-end" },
  3094: {
    originalName: "Rapid Firecannon",
    normalizedName: "rapid-firecannon",
  },
  3095: { originalName: "Stormrazor", normalizedName: "stormrazor" },
  3100: { originalName: "Lich Bane", normalizedName: "lich-bane" },
  3102: { originalName: "Banshee's Veil", normalizedName: "banshees-veil" },
  3105: {
    originalName: "Aegis of the Legion",
    normalizedName: "aegis-of-the-legion",
  },
  3107: { originalName: "Redemption", normalizedName: "redemption" },
  3108: { originalName: "Fiendish Codex", normalizedName: "fiendish-codex" },
  3109: { originalName: "Knight's Vow", normalizedName: "knights-vow" },
  3110: { originalName: "Frozen Heart", normalizedName: "frozen-heart" },
  3111: { originalName: "Mercury's Treads", normalizedName: "mercurys-treads" },
  3112: { originalName: "Guardian's Orb", normalizedName: "guardians-orb" },
  3113: { originalName: "Aether Wisp", normalizedName: "aether-wisp" },
  3114: { originalName: "Forbidden Idol", normalizedName: "forbidden-idol" },
  3115: { originalName: "Nashor's Tooth", normalizedName: "nashors-tooth" },
  3116: {
    originalName: "Rylai's Crystal Scepter",
    normalizedName: "rylais-crystal-scepter",
  },
  3117: { originalName: "Mobility Boots", normalizedName: "mobility-boots" },
  3119: {
    originalName: "Winter's Approach",
    normalizedName: "winters-approach",
  },
  3121: { originalName: "Fimbulwinter", normalizedName: "fimbulwinter" },
  3123: {
    originalName: "Executioner's Calling",
    normalizedName: "executioners-calling",
  },
  3124: {
    originalName: "Guinsoo's Rageblade",
    normalizedName: "guinsoos-rageblade",
  },
  3133: {
    originalName: "Caulfield's Warhammer",
    normalizedName: "caulfields-warhammer",
  },
  3134: { originalName: "Serrated Dirk", normalizedName: "serrated-dirk" },
  3135: { originalName: "Void Staff", normalizedName: "void-staff" },
  3139: {
    originalName: "Mercurial Scimitar",
    normalizedName: "mercurial-scimitar",
  },
  3140: {
    originalName: "Quicksilver Sash",
    normalizedName: "quicksilver-sash",
  },
  3142: {
    originalName: "Youmuu's Ghostblade",
    normalizedName: "youmuus-ghostblade",
  },
  3143: { originalName: "Randuin's Omen", normalizedName: "randuins-omen" },
  3145: {
    originalName: "Hextech Alternator",
    normalizedName: "hextech-alternator",
  },
  3152: {
    originalName: "Hextech Rocketbelt",
    normalizedName: "hextech-rocketbelt",
  },
  3153: {
    originalName: "Blade of The Ruined King",
    normalizedName: "blade-of-the-ruined-king",
  },
  3155: { originalName: "Hexdrinker", normalizedName: "hexdrinker" },
  3156: {
    originalName: "Maw of Malmortius",
    normalizedName: "maw-of-malmortius",
  },
  3157: {
    originalName: "Zhonya's Hourglass",
    normalizedName: "zhonyas-hourglass",
  },
  3158: {
    originalName: "Ionian Boots of Lucidity",
    normalizedName: "ionian-boots-of-lucidity",
  },
  3161: { originalName: "Spear Of Shojin", normalizedName: "spear-of-shojin" },
  3165: { originalName: "Morellonomicon", normalizedName: "morellonomicon" },
  3177: { originalName: "Guardian's Blade", normalizedName: "guardians-blade" },
  3179: { originalName: "Umbral Glaive", normalizedName: "umbral-glaive" },
  3181: { originalName: "Hullbreaker", normalizedName: "hullbreaker" },
  3184: {
    originalName: "Guardian's Hammer",
    normalizedName: "guardians-hammer",
  },
  3190: {
    originalName: "Locket of the Iron Solari",
    normalizedName: "locket-of-the-iron-solari",
  },
  3191: {
    originalName: "Seeker's Armguard",
    normalizedName: "seekers-armguard",
  },
  3193: {
    originalName: "Gargoyle Stoneplate",
    normalizedName: "gargoyle-stoneplate",
  },
  3211: { originalName: "Spectre's Cowl", normalizedName: "spectres-cowl" },
  3222: {
    originalName: "Mikael's Blessing",
    normalizedName: "mikaels-blessing",
  },
  3330: {
    originalName: "Scarecrow Effigy",
    normalizedName: "scarecrow-effigy",
  },
  3340: { originalName: "Stealth Ward", normalizedName: "stealth-ward" },
  3363: {
    originalName: "Farsight Alteration",
    normalizedName: "farsight-alteration",
  },
  3364: { originalName: "Oracle Lens", normalizedName: "oracle-lens" },
  3400: { originalName: "Your Cut", normalizedName: "your-cut" },
  3504: { originalName: "Ardent Censer", normalizedName: "ardent-censer" },
  3508: { originalName: "Essence Reaver", normalizedName: "essence-reaver" },
  3513: {
    originalName: "Eye of the Herald",
    normalizedName: "eye-of-the-herald",
  },
  3599: {
    originalName: "Kalista's Black Spear",
    normalizedName: "kalistas-black-spear",
  },
  3600: {
    originalName: "Kalista's Black Spear",
    normalizedName: "kalistas-black-spear",
  },
  3742: { originalName: "Dead Man's Plate", normalizedName: "dead-mans-plate" },
  3748: { originalName: "Titanic Hydra", normalizedName: "titanic-hydra" },
  3801: {
    originalName: "Crystalline Bracer",
    normalizedName: "crystalline-bracer",
  },
  3802: { originalName: "Lost Chapter", normalizedName: "lost-chapter" },
  3803: { originalName: "Catalyst of Aeons", normalizedName: "catalyst-of-aeons" },
  3814: { originalName: "Edge of Night", normalizedName: "edge-of-night" },
  3850: {
    originalName: "Spellthief's Edge",
    normalizedName: "spellthiefs-edge",
  },
  3851: { originalName: "Frostfang", normalizedName: "frostfang" },
  3853: {
    originalName: "Shard of True Ice",
    normalizedName: "shard-of-true-ice",
  },
  3854: {
    originalName: "Steel Shoulderguards",
    normalizedName: "steel-shoulderguards",
  },
  3855: {
    originalName: "Runesteel Spaulders",
    normalizedName: "runesteel-spaulders",
  },
  3857: {
    originalName: "Pauldrons of Whiterock",
    normalizedName: "pauldrons-of-whiterock",
  },
  3858: { originalName: "Relic Shield", normalizedName: "relic-shield" },
  3859: { originalName: "Targon's Buckler", normalizedName: "targons-buckler" },
  3860: {
    originalName: "Bulwark of the Mountain",
    normalizedName: "bulwark-of-the-mountain",
  },
  3862: { originalName: "Spectral Sickle", normalizedName: "spectral-sickle" },
  3863: {
    originalName: "Harrowing Crescent",
    normalizedName: "harrowing-crescent",
  },
  3864: {
    originalName: "Black Mist Scythe",
    normalizedName: "black-mist-scythe",
  },
  3901: {
    originalName:
      "<rarityLegendary>Fire at Will</rarityLegendary><br><subtitleLeft><silver>500 Silver Serpents</silver></subtitleLeft>",
    normalizedName:
      "<raritylegendary>fire-at-will</raritylegendary><br><subtitleleft><silver>500-silver-serpents</silver></subtitleleft>",
  },
  3902: {
    originalName:
      "<rarityLegendary>Death's Daughter</rarityLegendary><br><subtitleLeft><silver>500 Silver Serpents</silver></subtitleLeft>",
    normalizedName:
      "<raritylegendary>deaths-daughter</raritylegendary><br><subtitleleft><silver>500-silver-serpents</silver></subtitleleft>",
  },
  3903: {
    originalName:
      "<rarityLegendary>Raise Morale</rarityLegendary><br><subtitleLeft><silver>500 Silver Serpents</silver></subtitleLeft>",
    normalizedName:
      "<raritylegendary>raise-morale</raritylegendary><br><subtitleleft><silver>500-silver-serpents</silver></subtitleleft>",
  },
  3916: { originalName: "Oblivion Orb", normalizedName: "oblivion-orb" },
  4005: {
    originalName: "Imperial Mandate",
    normalizedName: "imperial-mandate",
  },
  4401: { originalName: "Force of Nature", normalizedName: "force-of-nature" },
  4403: {
    originalName: "The Golden Spatula",
    normalizedName: "the-golden-spatula",
  },
  4628: { originalName: "Horizon Focus", normalizedName: "horizon-focus" },
  4629: { originalName: "Cosmic Drive", normalizedName: "cosmic-drive" },
  4630: { originalName: "Blighting Jewel", normalizedName: "blighting-jewel" },
  4632: { originalName: "Verdant Barrier", normalizedName: "verdant-barrier" },
  4633: { originalName: "Riftmaker", normalizedName: "riftmaker" },
  4635: { originalName: "Leeching Leer", normalizedName: "leeching-leer" },
  4636: { originalName: "Night Harvester", normalizedName: "night-harvester" },
  4637: { originalName: "Demonic Embrace", normalizedName: "demonic-embrace" },
  4638: {
    originalName: "Watchful Wardstone",
    normalizedName: "watchful-wardstone",
  },
  4641: {
    originalName: "Stirring Wardstone",
    normalizedName: "stirring-wardstone",
  },
  4642: {
    originalName: "Bandleglass Mirror",
    normalizedName: "bandleglass-mirror",
  },
  4643: {
    originalName: "Vigilant Wardstone",
    normalizedName: "vigilant-wardstone",
  },
  4644: {
    originalName: "Crown of the Shattered Queen",
    normalizedName: "crown-of-the-shattered-queen",
  },
  4645: { originalName: "Shadowflame", normalizedName: "shadowflame" },
  6029: { originalName: "Ironspike Whip", normalizedName: "ironspike-whip" },
  6035: { originalName: "Silvermere Dawn", normalizedName: "silvermere-dawn" },
  6333: { originalName: "Death's Dance", normalizedName: "deaths-dance" },
  6609: {
    originalName: "Chempunk Chainsword",
    normalizedName: "chempunk-chainsword",
  },
  6616: {
    originalName: "Staff of Flowing Water",
    normalizedName: "staff-of-flowing-water",
  },
  6617: {
    originalName: "Moonstone Renewer",
    normalizedName: "moonstone-renewer",
  },
  6630: { originalName: "Goredrinker", normalizedName: "goredrinker" },
  6631: { originalName: "Stridebreaker", normalizedName: "stridebreaker" },
  6632: { originalName: "Divine Sunderer", normalizedName: "divine-sunderer" },
  6653: {
    originalName: "Liandry's Anguish",
    normalizedName: "liandrys-anguish",
  },
  6655: { originalName: "Luden's Tempest", normalizedName: "ludens-tempest" },
  6657: { originalName: "Rod of Ages", normalizedName: "rod-of-ages" },
  6656: { originalName: "Everfrost", normalizedName: "everfrost" },
  6660: { originalName: "Bami's Cinder", normalizedName: "bamis-cinder" },
  6662: {
    originalName: "Frostfire Gauntlet",
    normalizedName: "frostfire-gauntlet",
  },
  6664: { originalName: "Turbo Chemtank", normalizedName: "turbo-chemtank" },
  6665: { originalName: "Jak'Sho, The Protean", normalizedName: "jaksho-the-protean" },
  6667: { originalName: "Radiant Virtue", normalizedName: "radiant-virtue" },
  6670: { originalName: "Noonquiver", normalizedName: "noonquiver" },
  6671: { originalName: "Galeforce", normalizedName: "galeforce" },
  6672: { originalName: "Kraken Slayer", normalizedName: "kraken-slayer" },
  6673: {
    originalName: "Immortal Shieldbow",
    normalizedName: "immortal-shieldbow",
  },
  6675: {
    originalName: "Navori Quickblades",
    normalizedName: "navori-quickblades",
  },
  6676: { originalName: "The Collector", normalizedName: "the-collector" },
  6677: { originalName: "Rageknife", normalizedName: "rageknife" },
  6691: {
    originalName: "Duskblade of Draktharr",
    normalizedName: "duskblade-of-draktharr",
  },
  6692: { originalName: "Eclipse", normalizedName: "eclipse" },
  6693: { originalName: "Prowler's Claw", normalizedName: "prowlers-claw" },
  6694: { originalName: "Serylda's Grudge", normalizedName: "seryldas-grudge" },
  6695: { originalName: "Serpent's Fang", normalizedName: "serpents-fang" },
  6696: { originalName: "Axiom Arc", normalizedName: "axiom-arc" },
  7000: {
    originalName: "Sandshrike's Claw",
    normalizedName: "sandshrikes-claw",
  },
  7001: { originalName: "Syzygy", normalizedName: "syzygy" },
  7002: {
    originalName: "Draktharr's Shadowcarver",
    normalizedName: "draktharrs-shadowcarver",
  },
  7003: {
    originalName: "Turbocharged Hexperiment",
    normalizedName: "turbocharged-hexperiment",
  },
  7004: { originalName: "Forgefire Crest", normalizedName: "forgefire-crest" },
  7005: {
    originalName: "Rimeforged Grasp",
    normalizedName: "rimeforged-grasp",
  },
  7006: { originalName: "Typhoon", normalizedName: "typhoon" },
  7007: {
    originalName: "Wyrmfallen Sacrifice",
    normalizedName: "wyrmfallen-sacrifice",
  },
  7008: { originalName: "Bloodward", normalizedName: "bloodward" },
  7009: { originalName: "Icathia's Curse", normalizedName: "icathias-curse" },
  7010: { originalName: "Vespertide", normalizedName: "vespertide" },
  7011: {
    originalName: "Upgraded Aeropack",
    normalizedName: "upgraded-aeropack",
  },
  7012: { originalName: "Liandry's Lament", normalizedName: "liandrys-lament" },
  7013: { originalName: "Eye of Luden", normalizedName: "eye-of-luden" },
  7014: { originalName: "Eternal Winter", normalizedName: "eternal-winter" },
  7015: {
    originalName: "Ceaseless Hunger",
    normalizedName: "ceaseless-hunger",
  },
  7016: { originalName: "Dreamshatter", normalizedName: "dreamshatter" },
  7017: { originalName: "Deicide", normalizedName: "deicide" },
  7018: { originalName: "Infinity Force", normalizedName: "infinity-force" },
  7019: {
    originalName: "Reliquary of the Golden Dawn",
    normalizedName: "reliquary-of-the-golden-dawn",
  },
  7020: {
    originalName: "Shurelya's Requiem",
    normalizedName: "shurelyas-requiem",
  },
  7021: { originalName: "Starcaster", normalizedName: "starcaster" },
  7022: { originalName: "Seat of Command", normalizedName: "seat-of-command" },
  7023: { originalName: "Equinox", normalizedName: "equinox" },
  7024: { originalName: "Caesura", normalizedName: "caesura" },
  7025: { originalName: "Leviathan", normalizedName: "leviathan" },
  7026: { originalName: "The Unspoken Parasite", normalizedName: "the-unspoken-parasite" },
  7027: { originalName: "Primordial Dawn", normalizedName: "primordial-dawn" },
  7028: { originalName: "Infinite Convergence", normalizedName: "infinite-convergence" },
  7050: {
    originalName: "Gangplank Placeholder",
    normalizedName: "gangplank-placeholder",
  },
  8001: {
    originalName: "Anathema's Chains",
    normalizedName: "anathemas-chains",
  },
  8020: { originalName: "Abyssal Mask", normalizedName: "abyssal-mask" },
};

// description: "+25 ability haste<br/>+70 attack damage <br/><br/>Passive <br/><br/>
// +26 Lethality (16.18 − 26 (based on level) armor penetration) <br/>
// <br/>UNIQUE – NIGHTSTALKER: Basic attacking an enemy champion deals 100
//  (+ 30% bonus AD) bonus physical damage on-hit and Slow icon.png slows them by
//   99% for 0.25 seconds (15 second cooldown). Champion Damage rating.png
//    takedowns within 3 seconds reset this effect's cooldown and grant you
//     Twilight Shroud old2.png invisibility for 1.5 seconds. <br/>
//     <br/>MYTHIC PASSIVE: Empowers your other Legendary items with 5 ability haste.",
// from: [ 6691 ],

// {
//   '6691': {
//     colloq: '',
//     depth: 3,
//     description: '<mainText><stats><attention>60</attention> Attack Damage<br><attention>18</attention> Lethality<br><attention>20</attention> Ability Haste</stats><br><li><passive>Nightstalker:</passive> Attacking a champion deals an additional <physicalDamage>(75 + 30% bonus Attack Damage for melee / 55 + 25% bonus Attack Damage for ranged) physical damage</physicalDamage> (15s cooldown). If dealt by a Melee champion, this Attack also <status>Slows</status> the target by 99% for 0.25 seconds.  When a champion that you have damaged within the last 3 seconds dies, this cooldown is refreshed and you become <keywordStealth>Invisible</keywordStealth> for 1.5 seconds.<br><br><rarityMythic>Mythic Passive:</rarityMythic> Grants all other <rarityLegendary>Legendary</rarityLegendary> items <attention>5</attention> Ability Haste.<br></mainText><br>',
//     from: [ '3134', '3133' ],
//     gold: { base: 900, purchasable: true, sell: 2170, total: 3100 },
//     image: {
//       full: '6691.png',
//       group: 'item',
//       h: 48,
//       sprite: 'item2.png',
//       w: 48,
//       x: 0,
//       y: 96
//     },
//     into: [ '7002' ],
//     maps: { '11': true, '12': true, '21': true, '22': false },
//     name: 'Duskblade of Draktharr',
//     plaintext: '',
//     stats: { FlatPhysicalDamageMod: 60 },
//     tags: [
//       'Damage',
//       'Stealth',
//       'CooldownReduction',
//       'Slow',
//       'ArmorPenetration',
//       'AbilityHaste'
//     ]
//   }
// }
